export enum OrderItemStatus {
  None = '',
  AppraisalPending = 'AppraisalPending',
  AppraisalRevisionPending = 'AppraisalRevisionPending',
  InspectionPending = 'InspectionPending',
  InspectionComplete = 'InspectionComplete',
  EvaluationComplete = 'EvaluationComplete',
  ReportPending = 'ReportPending',
  Complete = 'Complete',
  CancelPending = 'CancelPending',
  Cancelled = 'Cancelled',
  QCReview = 'QCReview',
  InspectionRevision = 'InspectionRevision',
  InspectionReview = 'InspectionReview',
  InspectionCancelled = 'InspectionCancelled',
  InspectionCorrectionReview = 'InspectionCorrectionReview',
  ValuationReview = 'ValuationReview',
  RevisionRequested = 'RevisionRequested',
}
